"use strict";

import angular from "angular";

import template from "./employee-cost.component.html";
import "./themes/employee-cost.component-dark.scss";
import "./themes/employee-cost.component.scss";

import _ from "lodash";
class EmployeeCostComponent {
    constructor() {}

    $onInit() {
        this.employeeSalary = 1000;

        this.result = this.costGet();
    }

    $onChanges(changes) {
        if (
            !_.isEmpty(_.get(changes, "currentPeriod.previousValue")) ||
            !_.isEmpty(_.get(changes, "currentComparation.previousValue")) ||
            changes.series
        ) {
            this.employeeSalary = 1000;

            this.result = this.costGet();
        }
    }

    /**
     * @public
     * Get the last point value
     * @returns {Number}
     */
    costGet() {
        if (!_.get(this.points, "length") || !_.get(this.series, "length"))
            return 0;

        const points = this.points.filter(
            (p) => p.s == _.get(this.series, "[0]._id")
        );

        const point = points.find((p) => +p.t == +this.currentPeriod.date);

        return _.get(point, "m.v") || 0;
    }

    /**
     * @public
     * Recalcula o Custo Empregado
     */
    recalculateEmployeeCost = () => {
        return this.employeeSalary * this.result;
    };
}

EmployeeCostComponent.$inject = [];

const name = "employeeCostComponent";
const def = {
    bindings: {
        series: "<",
        configs: "<",
        points: "<",
        currentPeriod: "<",
        currentComparation: "<",
        source: "<",
        projection: "<",
        budget: "<",
        goals: "<",
        visualizationData: "<"
    },
    controller: EmployeeCostComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
